import { AudioNote, GoogleMeetMeeting, DetectedMeeting, RecallDetectedMeeting, CalendarEvent } from '@highlight/common'
import AudioNoteIpcRouter, { AudioNoteIpcRouterType } from '@shared/ipc/routers/AudioNoteIpc.router'

class AudioNoteIpcRenderer extends AudioNoteIpcRouter implements AudioNoteIpcRouterType {
  async getAudioNotesWithinTimeWindowDays(timeWindow: number) {
    return this.exec('getAudioNotesWithinTimeWindowDays', timeWindow)
  }

  async getAudioNotes() {
    return this.exec('getAudioNotes')
  }

  async getAudioNote(id: string) {
    return this.exec('getAudioNote', id)
  }

  async updateAudioNote(options: { id: string; updates: Partial<Omit<AudioNote, 'id'>> }) {
    return this.exec('updateAudioNote', options)
  }

  async deleteAudioNote(id: string) {
    return this.exec('deleteAudioNote', id)
  }

  async startRecording(meeting?: DetectedMeeting | GoogleMeetMeeting | RecallDetectedMeeting): Promise<boolean> {
    return this.exec('startRecording', meeting)
  }

  async stopRecording(save?: boolean) {
    return this.exec('stopRecording', save)
  }

  async pauseRecording() {
    return this.exec('pauseRecording')
  }

  async resumeRecording() {
    return this.exec('resumeRecording')
  }

  async clearAudioNoteState() {
    return this.exec('clearAudioNoteState')
  }

  async clearDetectedMeeting() {
    return this.exec('clearDetectedMeeting')
  }

  async startAwaitingMeetingJoin(meeting: CalendarEvent) {
    return this.exec('startAwaitingMeetingJoin', meeting)
  }

  async cancelAwaitingMeetingJoin() {
    return this.exec('cancelAwaitingMeetingJoin')
  }

  async generateSummaryForSavedNote() {
    return this.exec('generateSummaryForSavedNote')
  }

  async getAudioDebugInfo() {
    return this.exec('getAudioDebugInfo')
  }

  async applyAudioSessionSpeakerRename(payload: {
    audioSessionId: string
    dgSpeakerIndex: string
    name: string | null
  }) {
    return this.exec('applyAudioSessionSpeakerRename', payload)
  }
}

export default new AudioNoteIpcRenderer()
